var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoCameraBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.247 11.4402C21.7755 11.1692 21.214 11.1712 20.744 11.4452L18 13.0462V18.4537L20.744 20.0547C20.9805 20.1927 21.24 20.2617 21.5 20.2617C21.7565 20.2617 22.013 20.1947 22.247 20.0602C22.7185 19.7892 23 19.3032 23 18.7597V12.7417C23 12.1982 22.7185 11.7117 22.247 11.4412V11.4402Z",
    fill: "#017EA7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.301 10.6435C16.331 9.868 17 8.6385 17 7.25C17 4.903 15.097 3 12.75 3C10.403 3 8.5 4.903 8.5 7.25C8.5 8.5545 9.089 9.7205 10.014 10.5H7.2935C8.0335 9.815 8.5 8.838 8.5 7.75C8.5 5.679 6.821 4 4.75 4C2.679 4 1 5.679 1 7.75C1 8.964 1.5795 10.0405 2.4745 10.726C1.6075 11.119 1 11.988 1 13V18.5C1 19.8785 2.1215 21 3.5 21H14.5C15.8785 21 17 19.8785 17 18.5V13C17 11.903 16.2855 10.9795 15.301 10.6435ZM3.25 7.75C3.25 6.9215 3.9215 6.25 4.75 6.25C5.5785 6.25 6.25 6.9215 6.25 7.75C6.25 8.5785 5.5785 9.25 4.75 9.25C3.9215 9.25 3.25 8.5785 3.25 7.75ZM6 18.5H4C3.724 18.5 3.5 18.276 3.5 18C3.5 17.724 3.724 17.5 4 17.5H6C6.276 17.5 6.5 17.724 6.5 18C6.5 18.276 6.276 18.5 6 18.5ZM12.75 9.25C11.6455 9.25 10.75 8.3545 10.75 7.25C10.75 6.1455 11.6455 5.25 12.75 5.25C13.8545 5.25 14.75 6.1455 14.75 7.25C14.75 8.3545 13.8545 9.25 12.75 9.25Z",
    fill: "#017EA7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoCameraBlue);
export default __webpack_public_path__ + "static/media/videoCameraBlue.9bb3f78fd878692536212180e5862e07.svg";
export { ForwardRef as ReactComponent };